import { render, staticRenderFns } from "./MetadataModal.vue?vue&type=template&id=5fce54f4&"
import script from "./MetadataModal.vue?vue&type=script&lang=js&"
export * from "./MetadataModal.vue?vue&type=script&lang=js&"
import style0 from "./MetadataModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fce54f4')) {
      api.createRecord('5fce54f4', component.options)
    } else {
      api.reload('5fce54f4', component.options)
    }
    module.hot.accept("./MetadataModal.vue?vue&type=template&id=5fce54f4&", function () {
      api.rerender('5fce54f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History/MetadataModal.vue"
export default component.exports